import { render } from "./Mb060.vue?vue&type=template&id=7d984bb6&scoped=true"
import script from "./Mb060.vue?vue&type=script&lang=js"
export * from "./Mb060.vue?vue&type=script&lang=js"

import "./Mb060.vue?vue&type=style&index=0&id=7d984bb6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d984bb6"]])

export default __exports__